export const appSpacing = 12;
export const mobileTabMenuHeight = 64;
export const bookingModalSectionHeight = 680;
export const bookingModalSectionWidth = 640;
